<app-deprecated-confirmation-dialog
    #workScheduleDeleteModal
    header="time-off-v3.deleteWorkSchedule"
    description="time-off-v3.areYouSureYouWantToDeleteThisWorkSchedule"
    label="time-off-v3.delete"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="workSchedule.name"
        [back]="true"
        backRoute="/time-off/v3/settings"
        [menuService]="tabMenuService"
        [contextMenu]="!this.workSchedule.isDefault"
        contextMenuType="material"
    >
        <button mat-menu-item (click)="deleteWorkSchedule()">{{ 'time-off-v3.delete' | translate }}</button>
    </app-header>

    <app-overall-settings-card [workSchedule]="workSchedule"></app-overall-settings-card>

    <app-holidays-form
        [workSchedule]="workSchedule"
        [hasTimeOffImprovement]="hasTimeOffImprovement"
    ></app-holidays-form>

    <app-blackout-periods-form
        [workSchedule]="workSchedule"
        [hasTimeOffImprovement]="hasTimeOffImprovement"
    ></app-blackout-periods-form>
</div>
